import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../services/api';
import { useLang } from '../context/LanguageContext';

export default function VerifyEmailPage({ onDone }) {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { t } = useLang();
  const v = t.verifyEmail;

  const [status, setStatus] = useState('verifying');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-black text-slate-900 mb-1">{v.title}</h1>

        <div className="card mt-6">
          {status === 'verifying' && (
            <p className="text-sm text-slate-500">{v.verifying}</p>
          )}
          {status === 'success' && (
            <>
              <div className="bg-green-50 border border-green-100 text-green-700 text-sm px-4 py-3 rounded-xl mb-4">
                {v.successMsg}
              </div>
              <button onClick={onDone} className="w-full btn-primary justify-center">{v.backToSignIn}</button>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="bg-red-50 border border-red-100 text-red-600 text-sm px-4 py-3 rounded-xl mb-4">
                {v.errorMsg}
              </div>
              <button onClick={onDone} className="w-full btn-primary justify-center">{v.backToSignIn}</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
